import { useQuery } from 'vue-query';
import apiAxios from '../../apiAdminAxios';

const fetchAvgCommuteDistStats = async ({ type, from, to, week, employer_id }) => {
  let URL = '';
  if (type) {
    URL += `?type=${type}`;
  }
  if (from && to) {
    URL += `&from_year=${from}&to_year=${to}`;
  }

  if (week) {
    URL += `&week=${week}`;
  }
  if (employer_id) {
    URL += `&employer_id=${employer_id}`;
  }
  const { data } = await apiAxios.get(`/admin/stats/avg-commute-distance${URL}`);
  return data;
};

const fetchAvgCommuteModeDistStats = async ({ type, from, to, employer_id }) => {
  let URL = '';
  if (type) {
    URL += `?type=${type}`;
  }
  if (from && to) {
    URL += `&from_year=${from}&to_year=${to}`;
  }
  if (employer_id) {
    URL += `&employer_id=${employer_id}`;
  }
  const { data } = await apiAxios.get(`/admin/stats/avg-mile-commute-distance${URL}`);
  return data;
};
const useAvgCommuteDistanceQuery = ({ type, from, to, week, employer_id }) =>
  useQuery(
    ['avg-commute-distance-share-admin', type, from, to, employer_id],
    () => fetchAvgCommuteDistStats({ type, from, to, week, employer_id }),
    {
      cacheTime: 0,
      staleTime: 0,
    },
  );
const useAvgCommuteModeDistanceQuery = ({ type, from, to, employer_id }) =>
  useQuery(
    ['avg-commute-mode-distance-share-admin', type, from, to, employer_id],
    () => fetchAvgCommuteModeDistStats({ type, from, to, employer_id }),
    {
      cacheTime: 0,
      staleTime: 0,
    },
  );
const fetchCommuterAccessOddity = async ({ employerId, weekStart }) => {
  const { data } = await apiAxios.get('/admin/stats/commuter-access-oddity', {
    params: { employer_id: employerId, week_start: weekStart },
  });
  return data;
};
export default {
  useAvgCommuteDistanceQuery,
  useAvgCommuteModeDistanceQuery,
  fetchCommuterAccessOddity,
};
